module.exports = __webpack_public_path__ + "static/media/res3.c2288e5d.png";